/**
 * Where toasts sit on phones (sonner's layout below 600px). They clear the
 * floating bottom nav (fixed, about 90px tall with its gap); a sticky bar
 * above the nav, like the Profile Save / Cancel bar, can raise them further
 * by setting `MOBILE_TOAST_BOTTOM_VAR` on the root element.
 */
export const MOBILE_TOAST_BOTTOM_VAR = "--mobile-toast-bottom";

export const MOBILE_TOAST_OFFSET = {
  bottom: `var(${MOBILE_TOAST_BOTTOM_VAR}, 102px)`,
  left: 16,
  right: 16,
};
